export const sources = {
  gemeente: {
    id: 'gemeente',
    type: 'vector',
    pmtilesFile: 'Gemeente.pmtiles',
    promoteId: {
      Gemeente: 'ID_gemeente',
    },
  },
  statSector: {
    id: 'stat-sector',
    type: 'vector',
    pmtilesFile: 'Stat_sector.pmtiles',
    promoteId: {
      Stat_sector: 'ID_stat_sect',
    },
  },
};
